import React, { useRef } from "react";
import { Link } from "react-router-dom";
import {FaTimes, FaAlignRight  } from "react-icons/fa";
import ContactHeader from "./ContactHeader";
import WebLogo from "./WebLogo";
import "./allstyles.css";

function Navbar() {
  const navRef = useRef();

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  const closeNavbar = () => {
    navRef.current.classList.remove("responsive_nav");
  };

  return (
    <header>
      <ContactHeader />
       <WebLogo/>
      <nav ref={navRef}>
        <ul>
          <li >
            <Link to="/" onClick={closeNavbar}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={closeNavbar}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/wedding" onClick={closeNavbar}>
              Weddings
            </Link>
          </li>
          <li>
            <Link to="/outdoor" onClick={closeNavbar}>
              Outdoors
            </Link>
          </li>
          <li>
            <Link to="/babyshoot" onClick={closeNavbar}>
              Baby Shoot
            </Link>
          </li>
          <li>
            <Link to="/maternity" onClick={closeNavbar}>
              Maternity Shoot
            </Link>
          </li>
                    <li>
            <Link to="/contact" onClick={closeNavbar}>
              Contact
            </Link>
          </li>
        </ul>

        <button className="nav-btn nav-close-btn" onClick={showNavbar}>
          <FaTimes />
        </button>
      </nav>
      <button className="nav-btn" onClick={showNavbar}>
        <FaAlignRight  />
      </button>
    </header>
  );
}

export default Navbar;
